export default class DefaultCountryProvider {
  static async provider(): Promise<string | null> {
    if (typeof AbortController === "undefined") {
      return null;
    }

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 1000);

    return fetch("https://get.geojs.io/v1/ip/country.json", {
      signal: controller.signal,
    })
      .then(async (data) => {
        clearTimeout(timeoutId);
        const json = (await data.json()) as { country?: string | null };

        return json?.country ?? null;
      })
      .catch(() => {
        return null;
      });
  }
}
